import * as e from "react";
import c from "../lib/IconBase.es.js";
import r from "../defs/PencilSimple.es.js";
const o = e.forwardRef((i, m) => /* @__PURE__ */ e.createElement(c, { ref: m, ...i, weights: r }));
o.displayName = "PencilSimpleIcon";
const a = o;
export {
  a as PencilSimple,
  o as PencilSimpleIcon
};
